import { useEffect, useState } from "react";
import api from "../lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function usePush() {
  const [supported, setSupported] = useState(false);
  const [permission, setPermission] = useState("default");
  const [subscribed, setSubscribed] = useState(false);
  const [vapidKey, setVapidKey] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const ok = "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
    setSupported(ok);
    if (!ok) return;
    setPermission(Notification.permission);
    api.get("/push/vapid-public-key").then(({ data }) => {
      if (data.enabled) setVapidKey(data.public_key);
    }).catch(() => {});
    navigator.serviceWorker.getRegistration().then(async (reg) => {
      if (!reg) return;
      const sub = await reg.pushManager.getSubscription();
      setSubscribed(!!sub);
    });
  }, []);

  const subscribe = async () => {
    if (!supported || !vapidKey) return { ok: false, error: "Push non supportato" };
    setBusy(true);
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      await navigator.serviceWorker.ready;
      const perm = await Notification.requestPermission();
      setPermission(perm);
      if (perm !== "granted") { setBusy(false); return { ok: false, error: "Permesso negato" }; }
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });
      await api.post("/push/subscribe", { subscription: sub.toJSON() });
      setSubscribed(true);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e.message || "Errore push" };
    } finally { setBusy(false); }
  };

  const unsubscribe = async () => {
    setBusy(true);
    try {
      const reg = await navigator.serviceWorker.getRegistration();
      const sub = reg && (await reg.pushManager.getSubscription());
      if (sub) {
        await api.post("/push/unsubscribe", { subscription: sub.toJSON() });
        await sub.unsubscribe();
      }
      setSubscribed(false);
      return { ok: true };
    } catch (e) { return { ok: false, error: e.message }; }
    finally { setBusy(false); }
  };

  return { supported, permission, subscribed, vapidKey, busy, subscribe, unsubscribe, enabled: !!vapidKey };
}
